import { render, staticRenderFns } from "./ActivityDetail.vue?vue&type=template&id=c8026d6a&scoped=true&"
import script from "./ActivityDetail.vue?vue&type=script&lang=ts&"
export * from "./ActivityDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityDetail.vue?vue&type=style&index=0&id=c8026d6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8026d6a",
  null
  
)

export default component.exports